/**
 * Lightweight bus for prematch stats / league-table UI opened from event rows.
 * Consumed by PrematchStatisticsHost in AppShell.
 */

export type PrematchStatisticsRequest =
  | { kind: 'tablesleague' }
  | { kind: 'statscore'; eventId: number; language: string }
  | { kind: 'toast'; message: string };

type Listener = () => void;

let latest: PrematchStatisticsRequest | null = null;
let version = 0;
const listeners = new Set<Listener>();

function notify(): void {
  version += 1;
  for (const listener of listeners) listener();
}

export function requestPrematchStatistics(request: PrematchStatisticsRequest): void {
  latest = request;
  notify();
}

export function getPrematchStatisticsRequest(): PrematchStatisticsRequest | null {
  return latest;
}

export function getPrematchStatisticsRequestVersion(): number {
  return version;
}

export function clearPrematchStatisticsRequest(): void {
  if (!latest) return;
  latest = null;
  notify();
}

export function subscribePrematchStatisticsRequest(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
